@if (!isMultiRoomBooking) {
    <div class="row">
        <div class="col">
            <div class="confirmation-number">
                {{"cn.yourConfirmationNumberIs"|translate}}
                <span class="stay-box-value" [attr.data-testid]="'confirmation-number'">{{reservation.reservationId}}</span>
            </div>
        </div>
    </div>
}

<div class="row mt-3">
    <div class="col-12 stay-box-container" [attr.data-testid]="'confirmation-common-details'">
        <div class="stay-box">
            {{'cn.Arrival' | translate}}
            <div class="stay-box-value">{{reservation.searchMask.arrival| date}}</div>
            @if (hotelInfo.checkIn) {
                <div class="checkin">{{'cn.CheckIn' | translate}} {{hotelInfo.checkIn}}</div>
            }
        </div>

        <div class="stay-box">
            {{'cn.Departure' | translate}}
            <div class="stay-box-value">{{reservation.searchMask.departure | date}}</div>
            @if (hotelInfo.checkOut) {
                <div class="checkin">{{'cn.CheckOut' | translate}} {{hotelInfo.checkOut}}</div>
            }
        </div>

        <div class="col-12 col-lg-6">
            <div class="row">
                @if (contactDetails?.latLng) {
                <div class="col-6 pe-0 map-container">

                        <app-map [coordinates]="contactDetails?.latLng" [height]="'200px'"></app-map>

                </div>
                }
                <div class="col-6 ps-0">
                    <div class="stay-box --map">
                        <!-- <h4>{{"cn.hotelDetails" | translate}}</h4> -->
                        <b>{{hotelInfo.name}}</b>
                        {{contactDetails?.address}}, {{contactDetails?.zipCode}} {{contactDetails?.city}}, {{contactDetails?.country}}
                        <div>
                            {{"cn.Phone"|translate}}: <a href="{{'tel:'+contactDetails?.phone}}">{{contactDetails?.phone}}</a><br>
                        </div>
                        <div>
                            {{"cn.Email"|translate}}: <a href="{{'mailto:'+contactDetails?.email}}">{{contactDetails?.email}}</a>
                        </div>

                    </div>
                </div>

            </div>


        </div>

    </div>

</div>
